module.exports = __webpack_public_path__ + "static/media/instagram-dark-blue.9bb244c5.svg";